import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import CalendarFields from './CalendarFields'

export const CalendarCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <CalendarFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default CalendarCreate
